import Vue from 'vue'
// import * as VeeValidate from 'vee-validate'
import VeeValidate from 'vee-validate'
const config = {
    errorBagName: 'errorBags', // change if property conflicts.
    fieldsBagName: 'fieldBags',
};
Vue.use(VeeValidate, config);
